var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from 'src/ui/components/modal/Modal';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { useAutoPlayInactivity } from './hooks';
import { InfoMessage, E_INFO_MESSAGE_SEVERITY } from 'src/ui/components/InfoMessage/InfoMessage';
import styles from './AutoPlayInactivity.module.scss';
export var AutoPlayInactivity = function (props) {
    var i18n = props.i18n, onExit = props.onExit, _a = props.delayBeforeDisplayMs, delayBeforeDisplayMs = _a === void 0 ? 60000 : _a, _b = props.delayBeforeKickoutMs, delayBeforeKickoutMs = _b === void 0 ? 15000 : _b;
    var _c = useAutoPlayInactivity({
        onExit: onExit,
        delayBeforeDisplayMs: delayBeforeDisplayMs,
        delayBeforeKickoutMs: delayBeforeKickoutMs,
    }), isModalOpened = _c.isModalOpened, countdown = _c.countdown, handleResetModal = _c.handleResetModal;
    if (!isModalOpened) {
        return null;
    }
    var titleInactivityModal = getPropsByKeyPath(i18n.modules, 'userActivity.title');
    var textInactivityModal = getPropsByKeyPath(i18n.modules, 'userActivity.autoPlayText');
    var countdownTextTemplate = getPropsByKeyPath(i18n.modules, 'userActivity.autoPlayCountdown');
    var buttonExitInactivityModal = getPropsByKeyPath(i18n.modules, 'userActivity.buttonExitLabel');
    var buttonValidInactivityModal = getPropsByKeyPath(i18n.modules, 'userActivity.buttonLabel');
    var countdownText = countdownTextTemplate.replace('$countdown', "".concat(countdown, "s"));
    return (_jsx(Modal, __assign({ onClose: handleResetModal, title: titleInactivityModal }, { children: _jsxs("div", __assign({ className: styles.modalContent }, { children: [_jsx(InfoMessage, __assign({ severity: E_INFO_MESSAGE_SEVERITY.INFO, className: styles.infoMessage }, { children: _jsx("p", { children: countdownText }) })), _jsx("p", __assign({ className: styles.modalText }, { children: textInactivityModal })), _jsxs("div", __assign({ className: styles.actionsWrapper }, { children: [_jsx(Button, { type: EButtonType.NEUTRAL, isEdge: true, label: buttonExitInactivityModal, onClick: onExit }), _jsx(Button, { type: EButtonType.VALID, label: buttonValidInactivityModal, onClick: handleResetModal })] }))] })) })));
};
